import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      image:
        'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/515638ef4785b4755d4e9c4f44f60c36.jpeg',
      alt: '飼い主と犬が公園で幸せそうに過ごす様子',
    },
    {
      id: 2,
      image:
        'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/e4c4b762a073fc8d1df7ca3cae579466.jpeg',
      alt: '猫を優しく抱きしめる飼い主',
    },
    {
      id: 3,
      image:
        'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/2d39096c1c01802be4f97a3854a51315.jpeg',
      alt: '小鳥と触れ合う家族の穏やかなシーン',
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section className="relative h-[70vh] min-h-[500px] mt-20 overflow-hidden">
      {/* Image Slides with Fade Effect */}
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.alt}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
      ))}

      {/* Pagination Dots */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 flex gap-3">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentSlide
                ? 'bg-purple-500 w-8'
                : 'bg-white/50 hover:bg-white/70'
            }`}
            aria-label={`スライド ${index + 1} に移動`}
          ></button>
        ))}
      </div>

      {/* Hero Content */}
      <div className="absolute inset-0 flex items-center justify-start z-10 px-4 sm:px-8 lg:px-16">
        <div className="text-left max-w-4xl">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold text-white mb-4 sm:mb-5 leading-tight drop-shadow-lg">
            大切な家族との最後のお別れを、
            <br className="hidden sm:block" />
            心を込めてお手伝いします
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-white/95 mb-8 sm:mb-10 drop-shadow-md font-light">
            岡山市で20年以上の実績 | 小鳥からハムスター、大型犬まで対応
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-start justify-start gap-4 sm:gap-5">
            <a
              href="tel:086-012-3456"
              className="w-full sm:w-auto inline-flex items-center justify-center bg-white text-purple-600 px-6 sm:px-8 py-3 sm:py-4 rounded-2xl text-sm sm:text-base font-medium hover:bg-purple-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2 text-lg"></i>
              お電話でのご相談 086-012-3456
            </a>
            <Link
              to="/contact"
              className="w-full sm:w-auto inline-flex items-center justify-center bg-purple-500 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-2xl text-sm sm:text-base font-medium hover:bg-purple-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line mr-2 text-lg"></i>
              お問い合わせフォーム
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
